import React from 'react';

import { useIntl } from 'react-intl';

import scorecardIllustrationUrl from '../assets/scorecard-illustration.svg';
import { StateMessage } from '../state-message';

import messages from './messages';

export const ErrorState = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<StateMessage
			illustrationUrl={scorecardIllustrationUrl}
			title={intl.formatMessage(messages.errorStateTitle)}
			subtitle={intl.formatMessage(messages.errorStateSubtitle)}
			testId="rovo-for-you-error-state"
		/>
	);
};
